<script setup lang="ts">
import KgrIcon from '@shared/components/KgrIcon.vue';
import { useModuleEnabled } from '@shared/composables/useModuleEnabled';
import { computed } from 'vue';
import { RouterLink, useRoute } from 'vue-router';

const chatEnabled = useModuleEnabled('Chat');
const route = useRoute();
const locale = computed(() => (route.params.locale as string) || 'de');
</script>

<template>
    <div class="kgr-tabbar">
        <RouterLink
            class="kgr-tabbar__item"
            active-class="active"
            :to="`/${locale}/home`"
        >
            <KgrIcon
                name="house"
                class="kgr-tabbar__itemIcon"
            />
            <div class="kgr-tabbar__itemLabel">
                {{ $t('Home') }}
            </div>
        </RouterLink>
        <RouterLink
            class="kgr-tabbar__item"
            active-class="active"
            :to="`/${locale}/news`"
        >
            <KgrIcon
                name="notifications"
                class="kgr-tabbar__itemIcon"
            />
            <div class="kgr-tabbar__itemLabel">
                {{ $t('News') }}
            </div>
        </RouterLink>
        <RouterLink
            class="kgr-tabbar__item"
            active-class="active"
            :to="`/${locale}/events`"
        >
            <KgrIcon
                name="calendar"
                class="kgr-tabbar__itemIcon"
            />
            <div class="kgr-tabbar__itemLabel">
                {{ $t('Termine') }}
            </div>
        </RouterLink>
        <RouterLink
            v-if="chatEnabled"
            class="kgr-tabbar__item"
            active-class="active"
            :to="`/${locale}/chats`"
        >
            <KgrIcon
                name="chat"
                class="kgr-tabbar__itemIcon"
            />
            <div class="kgr-tabbar__itemLabel">
                {{ $t('Chats') }}
            </div>
        </RouterLink>
        <RouterLink
            class="kgr-tabbar__item"
            active-class="active"
            :to="`/${locale}/groups`"
        >
            <KgrIcon
                name="users"
                class="kgr-tabbar__itemIcon"
            />
            <div class="kgr-tabbar__itemLabel">
                {{ $t('Gruppen') }}
            </div>
        </RouterLink>
    </div>
</template>
